import type { HelpFile } from '../../types/help'
import { LdapProvisioningConfigEditorTestIds } from '../../../testids/LdapProvisioningConfigEditorTestIds'

export const ldapProvisioningConfigEditorHelp: HelpFile = {
  docPage: '/docs/systems/connectors',
  texts: {
    [LdapProvisioningConfigEditorTestIds.ldapProvisioningConfigCard]:
      'LDAP provisioning configuration — controls where accounts are placed in the directory, which object classes are assigned, and how distinguished names are constructed.',
    [LdapProvisioningConfigEditorTestIds.cardTitleLdapProvisioningConfig]:
      'LDAP provisioning settings — object classes, DN template, default OU, and OU routing rules.',
    [LdapProvisioningConfigEditorTestIds.objectClasses]:
      'LDAP object classes assigned to every account created by this connector — typical values: top, person, organizationalPerson, user (Active Directory), or inetOrgPerson (OpenLDAP).',
    [LdapProvisioningConfigEditorTestIds.ldapDnTemplate]:
      'Distinguished name template used to construct the DN of each provisioned account — must contain the {ou} placeholder. Example: cn={cn},{ou}.',
    [LdapProvisioningConfigEditorTestIds.ldapDefaultOu]:
      'Fallback organizational unit when no OU routing rule matches — also the sole OU when no rules are defined. Example: ou=Users,dc=example,dc=com.',
    [LdapProvisioningConfigEditorTestIds.ouRulesTable]:
      'OU routing rules determine which organizational unit receives a provisioned account — evaluated in order, first match applies, default OU used as fallback.',
    [LdapProvisioningConfigEditorTestIds.ouRulesReadonlyTable]:
      'Read-only view of the OU routing rules currently in effect.',
    [LdapProvisioningConfigEditorTestIds.ldapProvisioningConfigLoading]:
      'The LDAP provisioning configuration is still loading from the server — the form will appear once the request resolves.',
    [LdapProvisioningConfigEditorTestIds.colOuAttribute]:
      'Account attribute that the routing rule evaluates, for example department or location.',
    [LdapProvisioningConfigEditorTestIds.colOuOperator]:
      'Comparison operator used to match the attribute value (equals, in, starts-with, ...).',
    [LdapProvisioningConfigEditorTestIds.colOuValue]:
      'Value(s) the attribute must match for this routing rule to fire.',
    [LdapProvisioningConfigEditorTestIds.colOuTarget]:
      'Target organizational unit DN where matching accounts will be placed.',
    [LdapProvisioningConfigEditorTestIds.colOuActions]:
      'Per-row actions for the routing rule.',
    [LdapProvisioningConfigEditorTestIds.colOuAttributeReadonly]: null,
    [LdapProvisioningConfigEditorTestIds.colOuOperatorReadonly]: null,
    [LdapProvisioningConfigEditorTestIds.colOuValueReadonly]: null,
    [LdapProvisioningConfigEditorTestIds.colOuTargetReadonly]: null,
    [LdapProvisioningConfigEditorTestIds.btnAddOuRule]:
      'Add a new OU routing rule to the bottom of the list.',
    [LdapProvisioningConfigEditorTestIds.btnLdapSave]: null,
    [LdapProvisioningConfigEditorTestIds.btnLdapCancel]: null,
    [LdapProvisioningConfigEditorTestIds.ldapDirtyActions]:
      'Save and cancel actions — appear when the configuration has unsaved changes.',
    [LdapProvisioningConfigEditorTestIds.defaultOuError]:
      'Validation error: the default OU is missing or malformed.',
    [LdapProvisioningConfigEditorTestIds.dnTemplateError]:
      'Validation error: the DN template is missing or does not contain the required {ou} placeholder.',
  },
}
